import * as React from 'react';
import {
  Stack,
  CssBaseline,
  Typography,
  Drawer,
  Box,
  Divider,
  createTheme,
  ThemeProvider,
  Skeleton,
} from '@mui/material';
import PageNavigation from './PageNavigation';
import BottomNavigation from './BottomNavigation';
import { useAppSelector } from '../../hooks';
import { selectTheme } from '../../slices/global/themeSlice';
// import GlobalSearchText from '../GlobalSearchText';
// import FloatingBottomRightActions from '../FloatingBottomRightActions';
import { selectAuthPending } from '../../slices/global/authSlice';
import LoaderThreeDots from '../LoaderThreeDots';
const drawerWidth = 250;

export default function NavigationSideBar(props: { children?: React.ReactNode }) {
  const authPending = useAppSelector(selectAuthPending);

  React.useEffect(() => {
    console.log(`Authentication pending: ${authPending}`);
  });

  const mode = useAppSelector(selectTheme);

  const darkTheme = createTheme({
    palette: {
      mode: mode,
    },
  });

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#D01F2F',
          },
        }}
        variant="permanent"
        anchor="left"
      // display="flex"
      >
        <Stack sx={{ p: 2 }} alignItems="center" spacing={1}>
          <img
            src={require('../../static/img/AS-Logo-210w.jpg')}
            alt="AutoShack Logo"
            style={{ width: 210, height: 50 }}
          />
          <Typography variant="h6" sx={{ fontSize: 18 }} color="lightGrey">
            KapSys WMS
          </Typography>
          {/* <GlobalSearchText /> */}
        </Stack>
        <Divider component="div" role="presentation" sx={{ bgcolor: 'lightGrey' }} />
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {authPending ? (
            [0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
              <Skeleton
                key={i}
                variant="rounded"
                width="95%"
                height="30px"
                sx={{ p: 1, borderRadius: 25, m: 1, bgcolor: 'grey.900' }}
              />
            ))
          ) : (
            <>
              <Box>
                <PageNavigation />
              </Box>
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'flex-end',
                }}
              >
                <Box sx={{ flexGrow: 1 }} />
                <BottomNavigation />
              </Box>
            </>
          )}
        </Box>
      </Drawer>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 2 }}>
          <Box id="back-to-top-anchor" />
          {/* <FloatingBottomRightActions /> */}
          {authPending ? <LoaderThreeDots title="Loading..." /> : props.children}
        </Box>
      </ThemeProvider>
    </Box>
  );
}
